import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { api } from "./api";

const SalesComparisonChart = () => {
  const [chartData, setChartData] = useState([]);
  const [years, setYears] = useState([]);

  useEffect(() => {
    const fetchSalesData = async () => {
      try {
        const res = await api.get('/api/dash/sales-comparison');
        const { months, salesData } = res.data;

        // Extract year keys dynamically from salesData
        const yearKeys = Object.keys(salesData);
        setYears(yearKeys);

        // Format data for the chart
        const formatted = months.map((month, i) => {
          const entry = { month };
          yearKeys.forEach((year) => {
            entry[year] = salesData[year][i];
          });
          return entry;
        });

        setChartData(formatted);
      } catch (err) {
        console.error("Error fetching sales data:", err);
      }
    };

    fetchSalesData();
  }, []);

  return (
    <div>
      <h4 style={{ textAlign: "center", marginBottom: "20px" }}>Sales Comparison</h4>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Legend />
          {years.map((year, index) => (
            <Line
              key={year}
              type="monotone"
              dataKey={year}
              stroke={["#8884d8", "#82ca9d", "#ff7300", "#d45087", "#a05195", "#f95d6a", "#2f4b7c", "#665191"][index % 8]}
              name={`${year} `}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesComparisonChart;
